module.exports = __webpack_public_path__ + "static/media/mitten.d028f403.svg";